import { createStore, combineReducers, applyMiddleware } from 'redux'
import * as reducers from './reducer/reducers'
import createHistory from 'history/createBrowserHistory'
import { resolveMiddleware, Resolve, resolveReducer } from '@kairo/react-redux-resolve';
import { languageMiddleware } from './middleware/languageMiddleware'
import { routerReducer, routerMiddleware } from 'react-router-redux'
import { wpapi } from "../config/wpapi";
import { resolves } from '../config/resolve';
import {GravityFormsApi} from "../util/GravityFormsApi";

export const history = createHistory();
const resolve = new Resolve();

const middleware = [
  resolveMiddleware(resolve),
  languageMiddleware,
  routerMiddleware(history)
];

export const store = createStore(
  combineReducers({
    ...reducers,
    router: routerReducer,
    resolve: resolveReducer
  }),
  {
    WPAPI: {
      instance: wpapi
    },
    gravityFormsApi: new GravityFormsApi({
      apiKey: process.env.REACT_APP_GRAVITY_FORMS_APIKEY,
      domain: `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_DOMAIN}`,
      privateKey: process.env.REACT_APP_GRAVITY_FORMS_PRIVATEKEY
    })
  },
  applyMiddleware( ...middleware ),
);

const options = {
  baseName: /^[a-z]{2}/,
  routes: resolves(store),
  caseSensitive: false,
  store
};

resolve.init(options);



// WEBPACK FOOTER //
// ./src/redux/store.js